export default __webpack_public_path__ + "static/media/ic_sardinia.4d461ba7.svg";